import React from 'react'
import Header from '@/components/Header'
import { ArrowLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

export default function PrivacyPage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-black">
      <Header />
      <main className="pt-24 pb-16 max-w-3xl mx-auto px-6 md:px-12">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-sm text-[#f5f5f7]/50 hover:text-[#f5f5f7] transition-opacity duration-[180ms] mb-8"
        >
          <ArrowLeft size={16} />
          Retour
        </button>

        <h1 className="text-3xl sm:text-4xl tracking-tight font-bold text-[#f5f5f7] font-heading mb-2">
          Politique de Confidentialité
        </h1>
        <p className="text-sm text-[#f5f5f7]/40 mb-10">Dernière mise à jour : avril 2026</p>

        <div className="prose-custom space-y-8">
          <section>
            <h2>1. Responsable du traitement</h2>
            <p>
              Le responsable du traitement des données personnelles est la société <strong>WeDreamTeam</strong>,
              représentée par Fayçal Zouaoui, fondateur de LeasingMalin.
            </p>
            <ul>
              <li>Email : contact@leasingmalin.com</li>
              <li>Siège social : [adresse à compléter]</li>
            </ul>
          </section>

          <section>
            <h2>2. Données collectées</h2>
            <p>Dans le cadre de l'utilisation du service, nous collectons les données suivantes :</p>
            <ul>
              <li><strong>Données d'identification :</strong> nom, prénom, adresse email (lors de la création de compte)</li>
              <li><strong>Données du contrat :</strong> le document de leasing transmis par l'utilisateur (peut contenir nom, coordonnées, données financières, informations sur le véhicule)</li>
              <li><strong>Données de paiement :</strong> traitées exclusivement par Stripe. Nous ne stockons pas vos informations de carte bancaire</li>
              <li><strong>Données de connexion :</strong> adresse IP, type de navigateur, horodatages (à des fins de sécurité)</li>
            </ul>
            <p>
              <strong>Note :</strong> avant l'envoi de votre contrat, vous pouvez masquer les informations personnelles
              non nécessaires à l'analyse (nom, téléphone, adresse, nom de société). Ces données ne sont demandées
              que si une économie est avérée et que vous choisissez de poursuivre.
            </p>
          </section>

          <section>
            <h2>3. Finalité du traitement</h2>
            <p>Vos données sont collectées et traitées exclusivement pour :</p>
            <ul>
              <li>Analyser votre contrat de leasing et détecter une éventuelle économie</li>
              <li>Vous communiquer le résultat de l'analyse</li>
              <li>Exécuter le service choisi (envoi des instructions ou prise en charge des démarches)</li>
              <li>Gérer votre compte utilisateur</li>
              <li>Traiter le paiement si vous souscrivez à une offre</li>
            </ul>
            <p>
              Vos données ne sont <strong>jamais utilisées à des fins commerciales, publicitaires ou de prospection</strong>.
            </p>
          </section>

          <section>
            <h2>4. Non-revente des données</h2>
            <p>
              Vos données personnelles et les documents que vous transmettez ne sont <strong>jamais vendus,
              cédés, loués ni partagés</strong> avec des tiers à des fins commerciales.
            </p>
            <p>
              Les seuls tiers ayant accès à certaines données sont les sous-traitants techniques nécessaires
              au fonctionnement du service (hébergement cloud, traitement des paiements), dans le strict cadre
              de leurs missions et sous contrat de confidentialité.
            </p>
          </section>

          <section>
            <h2>5. Durée de conservation</h2>
            <ul>
              <li><strong>Documents de contrat :</strong> supprimés de nos serveurs une fois l'analyse terminée. Seul le résultat de l'analyse est conservé dans votre espace personnel</li>
              <li><strong>Données de compte :</strong> conservées tant que votre compte est actif. Supprimées dans un délai de 30 jours après la suppression de votre compte</li>
              <li><strong>Données de paiement :</strong> conservées par Stripe conformément à leurs obligations légales. Nous ne stockons aucune donnée de carte bancaire</li>
              <li><strong>Logs de connexion :</strong> conservés pendant 12 mois conformément aux obligations légales</li>
            </ul>
          </section>

          <section>
            <h2>6. Sécurité des données</h2>
            <p>
              Nous mettons en œuvre les mesures techniques et organisationnelles appropriées pour protéger
              vos données personnelles contre l'accès non autorisé, la perte, la destruction ou l'altération :
            </p>
            <ul>
              <li>Chiffrement des données en transit (HTTPS/TLS)</li>
              <li>Hébergement sécurisé sur infrastructure AWS (région Europe)</li>
              <li>Accès restreint aux données par le personnel autorisé uniquement</li>
              <li>Suppression automatique des documents après analyse</li>
            </ul>
          </section>

          <section>
            <h2>7. Vos droits (RGPD)</h2>
            <p>
              Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique
              et Libertés, vous disposez des droits suivants :
            </p>
            <ul>
              <li><strong>Droit d'accès :</strong> obtenir une copie de vos données personnelles</li>
              <li><strong>Droit de rectification :</strong> corriger des données inexactes ou incomplètes</li>
              <li><strong>Droit de suppression :</strong> demander l'effacement de vos données</li>
              <li><strong>Droit à la portabilité :</strong> recevoir vos données dans un format structuré</li>
              <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos données</li>
              <li><strong>Droit à la limitation :</strong> demander la limitation du traitement</li>
            </ul>
            <p>
              Pour exercer vos droits, envoyez un email à <strong>contact@leasingmalin.com</strong> en
              précisant votre demande et votre identité. Nous répondrons dans un délai de 30 jours.
            </p>
            <p>
              Vous pouvez également introduire une réclamation auprès de la CNIL (Commission Nationale
              de l'Informatique et des Libertés) : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-green-400 underline">www.cnil.fr</a>.
            </p>
          </section>

          <section>
            <h2>8. Cookies</h2>
            <p>Le site leasingmalin.com utilise les cookies suivants :</p>
            <ul>
              <li><strong>Cookies strictement nécessaires :</strong> authentification (session JWT), préférences de navigation. Ces cookies sont indispensables au fonctionnement du site</li>
              <li><strong>Cookies d'analyse :</strong> PostHog (analyse d'usage anonymisée) pour améliorer le service. Ces cookies peuvent être refusés sans impact sur le fonctionnement du site</li>
            </ul>
            <p>
              Aucun cookie publicitaire ou de pistage tiers n'est utilisé.
            </p>
          </section>

          <section>
            <h2>9. Modifications</h2>
            <p>
              La présente politique de confidentialité peut être mise à jour à tout moment. La date de
              dernière mise à jour est indiquée en haut de cette page. Nous vous invitons à la consulter
              régulièrement.
            </p>
          </section>

          <section>
            <h2>10. Contact</h2>
            <p>
              Pour toute question relative à la protection de vos données personnelles :
            </p>
            <ul>
              <li>Email : <strong>contact@leasingmalin.com</strong></li>
              <li>Responsable : Fayçal Zouaoui, WeDreamTeam</li>
            </ul>
          </section>
        </div>
      </main>
    </div>
  )
}
